require('./cardPaymentPurchaseDeferralTable.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ helpers
const { FormattedText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
// @ commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { LabelDate } = require('commonsComponents/labelDate');
// @ constants
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');
const TRANSLATION_KEY_PREFIX = 'cardPaymentPurchaseDeferralTable-';

class CardPaymentPurchaseDeferralTable extends React.Component {
    constructor(props) {
        super(props);

        this.buildTableBodyRows = this.buildTableBodyRows.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    buildTableBodyRows() {
        const { immInstallments } = this.props;
        const language = getLanguage();

        return immInstallments.map((installment, index) =>
            (<OKTableRow key={'rowData-' + index}>
                <OKTableCell className="card-payment-purchase-deferral-table__cell">
                    <LabelDate
                        date={installment.get('nextAmortizationDate')}
                        language={language}
                        today={LABEL_DATE_TODAY}
                        yesterday={LABEL_DATE_YESTERDAY}
                    />
                </OKTableCell>
                <OKTableCell className="card-payment-purchase-deferral-table__cell">
                    <OneLineSymbolAmount
                        amountObject={getPlainAmountObject(installment.get('interests'))}
                        language={language}
                        amountObjectFormatted={formatAmountObject(installment.get('interests'))} />
                </OKTableCell>
                <OKTableCell className="card-payment-purchase-deferral-table__cell">
                    <OneLineSymbolAmount
                        amountObject={getPlainAmountObject(installment.get('amortizedCapital'))}
                        language={language}
                        amountObjectFormatted={formatAmountObject(installment.get('amortizedCapital'))} />
                </OKTableCell>
                <OKTableCell className="card-payment-purchase-deferral-table__cell">
                    <OneLineSymbolAmount
                        amountObject={getPlainAmountObject(installment.get('installmentTotal'))}
                        language={language}
                        amountObjectFormatted={formatAmountObject(installment.get('installmentTotal'))} />
                </OKTableCell>
                <OKTableCell className="card-payment-purchase-deferral-table__cell">
                    <OneLineSymbolAmount
                        amountObject={getPlainAmountObject(installment.get('pendingCapital'))}
                        language={language}
                        amountObjectFormatted={formatAmountObject(installment.get('pendingCapital'))} />
                </OKTableCell>
            </OKTableRow>)
        );
    }

    buildTableHeader() {
        return [
            'date',
            'interests',
            'amortizedCapital',
            'installmentTotal',
            'pendingCapital'
        ].map((thLabel, index) =>
            (<OKTableCell
                asHeader={true}
                key={`thLabel-${index}`}
                className="card-payment-purchase-deferral-table__cell-header"
            >
                <FormattedText value={`${TRANSLATION_KEY_PREFIX}${thLabel}`} />
            </OKTableCell>)
        );
    }

    render() {
        const tableHeaderFields = this.buildTableHeader();
        const tableBodyRows = this.buildTableBodyRows();

        return (
            <section className="card-payment-purchase-deferral-table">
                <div className="card-payment-purchase-deferral-table__table">
                    <OKTable id="card-payment-purchase-deferral-table-0">
                        <thead>
                            <OKTableRow asHeader={true}>
                                {tableHeaderFields}
                            </OKTableRow>
                        </thead>
                        <tbody>
                            {tableBodyRows}
                        </tbody>
                    </OKTable>
                </div>
            </section>
        );
    }
}

CardPaymentPurchaseDeferralTable.propTypes = {
    immInstallments: PropTypes.array.isRequired
};

module.exports = CardPaymentPurchaseDeferralTable;
